import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "authCode_title" }
const _hoisted_2 = { class: "authCode_description" }
const _hoisted_3 = { class: "authCode_email" }
const _hoisted_4 = { class: "authCode_content" }
const _hoisted_5 = { class: "authCode_input" }
const _hoisted_6 = {
  key: 0,
  class: "authCode_input_error"
}
const _hoisted_7 = {
  key: 0,
  class: "authCode_button-continue_timer"
}

import AuthLayout from '@web/platform.v3/layouts/auth.vue'
import InputV3 from '@web/platform.v3/components/input.vue'
import AcButton from '@ui-kit/components/AcButton.vue'
import AuthEnterWith from '@web/platform.v3/components/auth/enter-with.vue'
import { MqResponsive } from 'vue3-mq'

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import PAGE_NAME from '@web/consts/PAGE_NAME'
import { useAuthCatchErrors } from '@web/platform.v3/composables/useAuthCatchErrors'
import useRedirectAfterLogin from '@web/platform.v3/composables/useRedirectAfterLogin'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AuthEmailCode'
},
  __name: 'auth-email-code',
  setup(__props) {



const { redirectAfterLogin } = useRedirectAfterLogin()

const store = useStore()
const router = useRouter()

const code = ref('')
const error = ref('')
const isLoading = ref(false)
const user = computed(() => store.getters['user/user'])
const storedEmail = computed(() => store.getters['authV3/email'])
const maskedDestinationEmail = computed(() => store.getters['authV3/maskedDestinationEmail'])
const isTimerActive = computed(() => store.getters['authV3/isTimerActive'])
const needStartTimer = computed(() => store.getters['authV3/needStartTimer'])
const timerSeconds = computed(() => store.getters['authV3/timerSeconds'])
const formatTimerSeconds = computed(() => {
  return `00:${timerSeconds.value.toString().padStart(2, '0')}`
})

const isDisabled = computed(() => isTimerActive.value)

const { catchError } = useAuthCatchErrors()

const handleContinue = async () => {
  if (code.value.length !== 4) return
  if (isLoading.value) return
  isLoading.value = true
  try {
    await store.dispatch('authV3/verifyEmailCode', { email: storedEmail.value, code: code.value })
    store.commit('authV3/reset')
    redirectAfterLogin(user.value)
  } catch (e) {
    error.value = catchError(e)
  } finally {
    isLoading.value = false
  }
}

async function handleSendAgain () {
  try {
    await store.dispatch('authV3/requestEmailCode', storedEmail.value)
    store.dispatch('authV3/startTimer', 60)
  } catch (e) {
    error.value = catchError(e)
  }
}
function handleEnterPhone () {
  handleChangeEmail()
  router.replace({ name: 'login', params: { type: 'phone' } })
}

function handleClose () {
  handleChangeEmail()
}

function handleChangeEmail () {
  code.value = ''
  error.value = ''
  store.commit('authV3/setNeedStartTimer', false)
  store.commit('authV3/setEmailStatus', 'email')
}

watch(needStartTimer, (newVal) => {
  if (newVal) {
    store.commit('authV3/setNeedStartTimer', false)
    store.dispatch('authV3/startTimer', timerSeconds.value || 60)
  }
}, {
  immediate: true,
  once: true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    class: "authCode",
    "show-agreement": false
  }, {
    preHeader: _withCtx(() => [
      _createVNode(_unref(MqResponsive), { target: "mobile" }, {
        default: _withCtx(() => [
          _createElementVNode("div", { class: "authCode_preHeader" }, [
            _createElementVNode("div", {
              class: "authCode_close",
              onClick: handleClose
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("svg", {
                width: "28",
                height: "28",
                viewBox: "0 0 28 28",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("g", { "clip-path": "url(#clip0_20785_78407)" }, [
                  _createElementVNode("path", {
                    d: "M8 8L20 20M20 8L8 20",
                    stroke: "#203454",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round"
                  })
                ]),
                _createElementVNode("defs", null, [
                  _createElementVNode("clipPath", { id: "clip0_20785_78407" }, [
                    _createElementVNode("rect", {
                      width: "28",
                      height: "28",
                      fill: "white"
                    })
                  ])
                ])
              ], -1)
            ]))])
          ])
        ]),
        _: 1
      })
    ]),
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('auth.code.titleEmail')), 1)
    ]),
    description: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('auth.code.descriptionEmail')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(maskedDestinationEmail.value) + " ", 1),
        _createElementVNode("span", {
          onClick: handleChangeEmail,
          class: "authCode_email_change"
        }, _toDisplayString(_ctx.$t('change')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "authCode_form",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(InputV3, {
              modelValue: code.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
              placeholder: "0000",
              label: _ctx.$t('auth.code.code'),
              type: "number",
              maxlength: 4,
              onInput: handleContinue,
              loading: isLoading.value,
              autofocus: ""
            }, null, 8, ["modelValue", "label", "loading"]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(AcButton, {
              class: "authCode_button-continue",
              type: "button",
              variant: "tonal",
              block: "",
              disabled: isDisabled.value,
              onClick: handleSendAgain
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('auth.code.getNewCode')) + " ", 1),
                (isTimerActive.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(formatTimerSeconds.value), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32),
        _createVNode(AuthEnterWith),
        _createVNode(AcButton, {
          variant: "text",
          color: "gray",
          class: "authCode_enter-phone",
          block: "",
          onClick: handleEnterPhone
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('auth.enterByPhone')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})